import { defineStore, acceptHMRUpdate } from 'pinia'

export interface NewsItems{
  AltText: string,
  BrowserTitle: string,
  Code: string,
  DateEnd: string,
  DateStart: string,
  DownloadDescription: string,
  DownloadLanguage: string,
  DownloadNumberOfPages: string,
  DownloadPath: string,
  DownloadSize: string,
  DownloadTitle: string,
  FormCode: string,
  FormEmail: string,
  HeaderImage: string,
  HeaderImageDescription: string,
  HeaderImageTitle: string,
  HeaderType: string,
  LanguageCode: string,
  MainText: string,
  MetaDescription: string,
  MetaKeywords: string,
  MetaTitle: string,
  NameMenu: string,
  NameUrl: string,
  Priority: string,
  SocialMediaDescription: string,
  SocialMediaTitle: string,
  ThumbnailAltText: string,
  ThumbnailPath: string,
  Title: string,
  Usp: string
}

export const useNewsOverviewStore = defineStore('newsOverview', {
  state: () => ({
    Code: '',
    LanguageCode: '',
    NewsItems: [] as NewsItems[],
    initialized: false,
    loading: false,
  }),

  getters: {
    getAll: (state) => () => {
      return state.NewsItems;
    }
  },

  actions: {
    setInitialized(value: boolean) {
      this.initialized = value;
    },

    setLoading(value: boolean) {
      this.loading = value;
    },

    populate(newsItemsData : any) {
      if (!newsItemsData) {
        console.error('No newsItemsData included')
        return
      }

      // newsItemsData is een array
      if (Array.isArray(newsItemsData)) {
        this.Code = ''
        this.LanguageCode = ''
        this.NewsItems = newsItemsData
        this.setInitialized(true)
        return
      }

      // newsItemsData is een Object met Code, LanguageCode en NewsItems properties
      this.Code = newsItemsData.Code ? newsItemsData.Code : '';
      this.LanguageCode = newsItemsData.LanguageCode ? newsItemsData.LanguageCode : '';
      this.NewsItems = Array.isArray(newsItemsData.NewsItems) ? newsItemsData.NewsItems : []
      this.setInitialized(true)
    },

    reset() {
      this.$reset()
      this.initialized = false
      this.loading = false
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNewsOverviewStore, import.meta.hot))
}